import { useState, useEffect } from 'react';
import StyledLink from '@components/common/Link';
import { StepsWrapper, StepsButtons, CardsWrapper, Card, CardImage } from './EarnSteps.styles';
import LogoCurve from '@public/logo-curve.png';
import { LogoArch } from '@components/icons';
import Image from 'next/image';

export function EarnSteps() {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    setLoaded(true);
  }, []);
  return (
    <StepsWrapper>
      <h2>How do I Provide Liquidity?</h2>
      <CardsWrapper>
        <Card>
          <CardImage>
            <Image src={LogoCurve} width={90} height={90} alt="Curve Logo" />
          </CardImage>
          <h1>1</h1>
          <p>Go to the 3CRV/lvUSD Curve Pool</p>
        </Card>
        <Card>
          <CardImage>
            <Image src="/earn/StableCoins.svg" alt="" width={86} height={80} />
          </CardImage>
          <h1>2</h1>
          <p>Deposit and Stake USDC, USDT, or DAI</p>
        </Card>
        <Card>
          <CardImage>
            <LogoArch />
          </CardImage>
          <h1>3</h1>
          <p>Earn rewards in ARCH Tokens</p>
        </Card>
      </CardsWrapper>
      <StepsButtons>
        <StyledLink target="_blank" href="https://curve.fi/#/ethereum/pools/factory-v2-268/deposit" variant="button">
          Provide Liquidity on Curve
        </StyledLink>
        <StyledLink
          href="https://docs.archimedesfi.com/liquidity-providing-(lender)/how-to-provide-liquidity-(step-by-step)"
          variant="outline"
        >
          Step by Step Guide
        </StyledLink>
      </StepsButtons>
    </StepsWrapper>
  );
}
